module.exports = __webpack_public_path__ + "img/provider_search.9eaaad4d.svg";